<dx-drawer class="drawer" position="before" [closeOnOutsideClick]="shaderEnabled" [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode" [minSize]="minMenuSize" [shading]="shaderEnabled" [(opened)]="menuOpened">

  <app-side-navigation-menu [compactMode]="!menuOpened" [selectedItem]="selectedRoute" [ngClass]="swatchClassName"
    *dxTemplate="let dataMenu of 'panel'" (selectedItemChanged)="navigationChanged($event)"
    (openMenu)="navigationClick()">
    <!-- <dx-toolbar id="navigation-header" style="border-radius:10px 10px 0 0;">
      <dxi-toolbar-item *ngIf="minMenuSize !== 0" location="before" cssClass="menu-button" widget="dxButton" [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
        }">
      </dxi-toolbar-item>
      <dxi-toolbar-item location="before" cssClass="header-title" [text]="title">
      </dxi-toolbar-item>
    </dx-toolbar> -->
   <div style=" display: flex; justify-content: space-around; padding: 0 15%; border-top: 1px solid #ccc; border-left: 1px solid #ccc; border-right: 1px solid #ccc; align-items: center; background-color: #f7f7f7; border-radius: 10px 10px 0 0;">
      <img src="assets/icons/sidebar_logo2.png" width="70px" height="70px" alt="Asha" style="margin-top: 1rem;"/>
      <img src="assets/icons/sidebar_logo1.png" width="70px" height="70px" alt="Asha" style="margin-top: 1rem;"/>
      <!-- <h1 class="asha-logo">ASHA</h1> -->
    </div>
  </app-side-navigation-menu>

  <div class="container">
    <app-header [menuToggleEnabled]="minMenuSize === 0" (menuToggle)="menuOpened = !menuOpened;">
    </app-header>

    <dx-scroll-view class="layout-body with-footer">
      <div class="sty">
        <ng-content></ng-content>
      </div>
    </dx-scroll-view>
  </div>
</dx-drawer>